import { c as _c } from "react/compiler-runtime";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveOutcomesRepRank from "./CreateWaveOutcomesRepRank";
import CreateWaveOutcomesRepApprove from "./CreateWaveOutcomesRepApprove";
import type { JSX } from "react";
export default function CreateWaveOutcomesRep(t0) {
  const $ = _c(10);
  const {
    waveType,
    onOutcome,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== onCancel || $[1] !== onOutcome) {
    t1 = <CreateWaveOutcomesRepApprove onOutcome={onOutcome} onCancel={onCancel} />;
    $[0] = onCancel;
    $[1] = onOutcome;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onCancel || $[4] !== onOutcome) {
    t2 = <CreateWaveOutcomesRepRank onOutcome={onOutcome} onCancel={onCancel} />;
    $[3] = onCancel;
    $[4] = onOutcome;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = {
      [ApiWaveType.Approve]: t1,
      [ApiWaveType.Rank]: t2,
      [ApiWaveType.Chat]: t3
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const components = t4;
  return components[waveType];
}